import Owner from "../app/modules/Owner";

export const MODULES = {
  TENANTS: "tenant",
  PROPERTIES: "property",
  MANAGERS: "managers",
  SERVICE_PROVIDERS: "serviceProvider",
  MAINTENANCE: "maintenance",
  CONFIGURATIONS: "configurations",
  TICKETS: "tickets",
  TECHNICIANS: "technicians",
  ZONES: "zones",
  SERVICE_REQUESTS: "serviceRequests",
  ROSTER: "roster",
  CONTRACTS: "contracts",
  OWNERS: "owners",
  USERS: "users",
  NOTICE: "notice",
  DASHBOARD: "dashboard",
  CONTACTS: "contacts",
};
